import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type S3StaticDatum = {
  id: number;
  name?: string;
  isin?: string;
  code?: string;
  ticker?: string;
  currency?: string;
  asset_class_1?: string;
  asset_class_2?: string;
  has_transactions?: boolean;
  has_time_series?: boolean;
};

export const porfolios_columns: ColumnDef<S3StaticDatum>[] = [
  { accessorKey: "id", header: "Id" },
  { accessorKey: "name", header: "Nom" },
  { accessorKey: "isin", header: "ISIN" },
  { accessorKey: "code", header: "Code" },
  { accessorKey: "ticker", header: "Ticker" },
  { accessorKey: "currency", header: "Devise" },
  { accessorKey: "asset_class_1", header: "Classe d'actifs" },
  { accessorKey: "asset_class_2", header: "Sous-classe d'actifs" },
  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;
      const hasTimeSeries = row.original.has_time_series;

      return (
        <div className="flex gap-11 justify-end">
          <div className="flex gap-3">
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.S3}/${Tables.S3_TRANSACTIONS}`,
              )}
              queryParams={{
                s3_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Transactions
            </ExternalLink>
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.S3}/${Tables.S3_TIME_SERIES}`,
              )}
              queryParams={{
                s3_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTimeSeries ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Valorisations
            </ExternalLink>
          </div>
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
